import { inject, provide, type InjectionKey } from 'vue'

type InferContextType<Ctx> = Ctx extends InjectionKey<infer V> ? V : Ctx

export const createContext = <T, K extends InjectionKey<T>>(key: K) => {
  const provider = (value: InferContextType<K>) => provide(key, value)
  const consumer = (fallback?: InferContextType<K>) => {
    const resolved = inject(key, fallback)
    if (!resolved) {
      throw new Error(`Could not resolve ${key.description}`)
    }
    return resolved
  }

  return [provider, consumer, key] as const
}
